<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc">
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="SOM_pre"><a href="#/pre2">Introduction</a></div>
<div class="SOM_chap"><a href="#/chap1">Week One: Chapter One</a></div>
<div class="SOM_niv1"><span href="#/chap2" title="Link target outside of Sample">Week One Group Discussion</span></div>
<div class="SOM_chap"><span href="#/chap3" title="Link target outside of Sample">Week Two: Chapter Two</span></div>
<div class="SOM_niv1"><span href="#/chap4" title="Link target outside of Sample">Week Two Group Discussion</span></div>
<div class="SOM_chap"><span href="#/chap5" title="Link target outside of Sample">Week Three: Chapter Three</span></div>
<div class="SOM_niv1"><span href="#/chap6" title="Link target outside of Sample">Week Three Group Discussion</span></div>
<div class="SOM_chap"><span href="#/chap7" title="Link target outside of Sample">Week Four: Chapter Four</span></div>
<div class="SOM_niv1"><span href="#/chap8" title="Link target outside of Sample">Week Four Group Discussion</span></div>
<div class="SOM_chap"><span href="#/chap9" title="Link target outside of Sample">Week Five: Chapter Five</span></div>
<div class="SOM_niv1"><span href="#/chap10" title="Link target outside of Sample">Week Five Group Discussion</span></div>
<div class="SOM_chap"><span href="#/chap11" title="Link target outside of Sample">Week Six: Chapter Six</span></div>
<div class="SOM_niv1"><span href="#/chap12" title="Link target outside of Sample">Week Six Group Discussion</span></div>
<div class="SOM_chap"><span href="#/chap13" title="Link target outside of Sample">Week Seven: Chapters Seven and Eight</span></div>
<div class="SOM_niv1"><span href="#/chap14" title="Link target outside of Sample">Week Seven Group Discussion</span></div>
<div class="SOM_chap"><span href="#/chap15" title="Link target outside of Sample">Week Eight: Chapter Nine</span></div>
<div class="SOM_niv1"><span href="#/chap16" title="Link target outside of Sample">Week Eight Group Discussion</span></div>
<div class="SOM_chap"><span href="#/chap17" title="Link target outside of Sample">Week Nine: Chapter Ten</span></div>
<div class="SOM_niv1"><span href="#/chap18" title="Link target outside of Sample">Week Nine Group Discussion</span></div>
<div class="SOM_chap"><span href="#/chap19" title="Link target outside of Sample">Week Ten: Chapter Eleven</span></div>
<div class="SOM_niv1"><span href="#/chap20" title="Link target outside of Sample">Week Ten Group Discussion</span></div>
<div class="SOM_chap"><span href="#/chap21" title="Link target outside of Sample">Week Eleven: Chapters Twelve and Thirteen</span></div>
<div class="SOM_niv1"><span href="#/chap22" title="Link target outside of Sample">Week Eleven Group Discussion</span></div>
<div class="SOM_chap"><span href="#/chap23" title="Link target outside of Sample">Week Twelve: Chapter Fourteen</span></div>
<div class="SOM_niv1"><span href="#/chap24" title="Link target outside of Sample">Week Twelve Group Discussion</span></div>
<div class="SOM_appen"><span href="#/appen4" title="Link target outside of Sample">Praise for <i>Barefoot Study Guide</i></span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample">About the Author</span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?d939975e